import React, { useState } from "react";
import { Grid, Icon, List, Popup, Responsive } from "semantic-ui-react";
import { displayGender } from "utils/displayGender";
import { getFullName } from "utils/displayName";
import moment from "moment";
import ContainerField from "components/ContainerField";
import { formatPhoneNumberToInternational } from "utils/phone";
import { getPatientHomeAddress } from "utils/address";
import WhiteButtonEditBloc from "components/Buttons/WhiteButtonEditBloc";
import { capitalize } from "utils/patientConverter";

const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

const styles = {
	mainContainer: {
		backgroundColor: "rgb(1, 111, 97)",
		color: "#fff",
		borderRadius: "4px",
		border: "1px solid rgb(1, 111, 97)",
		boxShadow: "0px 9px 20px -23px rgba(148,148,148,1)",
		width: "100%",
		display: "flex",
		alignItems: "center",
		maxHeight: "102px",
		overflowY: "auto",
	},
	row: {
		paddingTop: 3,
		paddingBottom: 3,
	},
	rowWarning: {
		paddingTop: 3,
		paddingBottom: 3,
		backgroundColor: "#f2cfcf",
		margin: "10px",
		color: "brown",
		borderRadius: "15px",
		padding: "10px",
		fontSize: "0.9em",
		maxHeight: "71px",
		overflowY: "scroll",
	},
};

const SidebarPatientCard = ({
	patient,
	parameters,
	openEditPatient,
	openContactModal,
	openGranteeModal,
	errorsPatient,
	isTabletOrLess,
	isTelesec,
	displayAllPatientCard,
	toggleDisplayAllPatientCard,
}) => {
	const patientAddress = getPatientHomeAddress(patient);

	return (
		<>
			{isTabletOrLess && (
				<Grid style={styles.mainContainer}>
					<Grid.Row style={styles.row}>
						<Grid.Column mobile={16}>
							<ContainerField
								field={
									<>
										{displayGender(patient, parameters)} {getFullName(patient)}
									</>
								}
								icon={<Icon name="user" />}
								label=""
							/>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			)}
			{!isTabletOrLess && (
				<Grid style={styles.mainContainer}>
					<Grid.Row style={styles.row}>
						<Grid.Column mobile={12} tablet={12} computer={12}>
							Patient
							{errorsPatient.length > 0 && (
								<Popup
									position="bottom left"
									content={
										<div>
											<List bulleted items={errorsPatient} />
										</div>
									}
									on="click"
									pinned
									trigger={
										<div
											style={{
												backgroundColor: "#f6c8af",
												color: "brown",
												display: "inline",
												borderRadius: "8px",
												padding: "3px 6px",
												marginLeft: "10px",
												cursor: "help",
											}}
										>
											<Icon name="warning sign" color="red" /> Données du patient à mettre à jour !
										</div>
									}
								/>
							)}
						</Grid.Column>
						{!isTabletOrLess && !isTelesec && (
							<Grid.Column
								mobile={4}
								tablet={4}
								computer={4}
								style={{
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<WhiteButtonEditBloc
									text="Modifier"
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										openEditPatient();
									}}
								/>
							</Grid.Column>
						)}
					</Grid.Row>
					<Grid.Row style={{ ...styles.row, cursor: !!displayAllPatientCard ? "zoom-out" : "zoom-in" }} onClick={toggleDisplayAllPatientCard}>
						<Grid.Column computer={5} tablet={8} mobile={16}>
							<ContainerField
								field={
									<>
										{displayGender(patient, parameters)} {getFullName(patient)}
									</>
								}
								icon={<Icon name="user" />}
								label=""
							/>
						</Grid.Column>
						<Grid.Column computer={5} tablet={8} mobile={16}>
							<ContainerField
								field={(patient.cns || "N° CNS n.c.").concat(patient.specialRegime ? "  -  " + patient.specialRegime.acronym : " - Régime n.c.")}
								icon={<Icon name="id card" />}
								label=""
							/>
						</Grid.Column>
						{!isTabletOrLess && patient.grantees && patient.grantees.length > 0 && (
							<Grid.Column mobile={8} tablet={8} computer={5} style={{ fontWeight: "bold", padding: "0" }}>
								<ContainerField onClick={openGranteeModal} useButton={false} style={{ cursor: "zoom-in" }} label="Donne accès à ses résultats à :" />
							</Grid.Column>
						)}
					</Grid.Row>
					{!!displayAllPatientCard && (
						<Grid.Row style={styles.row}>
							<Grid.Column computer={10} tablet={8} mobile={16}>
								<ContainerField
									field={
										patient.birth_date
											? `${moment(patient.birth_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)} (${moment().diff(
													patient.birth_date,
													"years"
											  )} ans)`
											: "n.c."
									}
									icon={<Icon name="birthday" />}
									label=""
								/>
							</Grid.Column>
							{!isMobile() && (
								<Grid.Column mobile={8} tablet={8} computer={5} style={{ padding: "0" }}>
									{patient.grantees && patient.grantees.length > 0 && (
										<ContainerField
											onClick={openGranteeModal}
											useButton={false}
											style={{ cursor: "zoom-in" }}
											field={
												<span>
													{patient.grantees[0].grantee?.last_name?.toUpperCase() ?? patient.grantees[0].grantee?.birth_name?.toUpperCase()}{" "}
													{capitalize(patient.grantees[0].grantee?.first_name)} ({patient.grantees[0].relation ?? ""})
												</span>
											}
											label=""
										/>
									)}
								</Grid.Column>
							)}
						</Grid.Row>
					)}
					{!isMobile() && !!displayAllPatientCard && (
						<Grid.Row style={styles.row}>
							<Grid.Column computer={5} tablet={8} mobile={16}>
								<ContainerField
									field={
										patient.mobile_phone
											? `${formatPhoneNumberToInternational(patient.mobile_phone)}${patient.mobile_phone_is_relative ? " - Tuteur " : ""}${
													patient.mobile_phone_comment ? ` - ${patient.mobile_phone_comment}` : ""
											  }`
											: "n.c."
									}
									onClick={openContactModal}
									useButton={false}
									style={{ cursor: "zoom-in" }}
									icon={<Icon name="mobile alternate" />}
									label=""
								/>
							</Grid.Column>
							<Grid.Column computer={5} tablet={8} mobile={16}>
								<ContainerField
									field={
										patient.phone
											? `${formatPhoneNumberToInternational(patient.phone)}${patient.phone_comment ? ` - ${patient.phone_comment}` : ""}`
											: "n.c."
									}
									onClick={openContactModal}
									useButton={false}
									style={{ cursor: "zoom-in" }}
									icon={<Icon name="phone" />}
									label=""
								/>
							</Grid.Column>
							{!isMobile() && (
								<Grid.Column mobile={8} tablet={8} computer={5} style={{ padding: "0" }}>
									{patient.grantees && patient.grantees.length > 1 && (
										<ContainerField
											onClick={openGranteeModal}
											useButton={false}
											style={{ cursor: "zoom-in" }}
											field={
												<span>
													{patient.grantees[1].grantee?.last_name?.toUpperCase() ?? patient.grantees[1].grantee?.birth_name?.toUpperCase()}{" "}
													{capitalize(patient.grantees[1].grantee?.first_name)} ({patient.grantees[1].relation ?? ""})
												</span>
											}
											label=""
										/>
									)}
								</Grid.Column>
							)}
						</Grid.Row>
					)}
					{!isMobile() && !!displayAllPatientCard && (
						<Grid.Row style={styles.row}>
							<Grid.Column mobile={8} tablet={8} computer={10}>
								<ContainerField
									field={
										patient.email
											? `${patient.email}${patient.email_comment ? ` - ${patient.email_comment}` : ""}
											`
											: "n.c."
									}
									onClick={openContactModal}
									useButton={false}
									style={{ cursor: "zoom-in" }}
									icon={<Icon name="mail" />}
									label=""
								/>
							</Grid.Column>
							<Grid.Column mobile={8} tablet={8} computer={5} style={{ padding: "0" }}>
								{patient.grantees && patient.grantees.length > 2 && (
									<ContainerField
										onClick={openGranteeModal}
										useButton={false}
										style={{ cursor: "zoom-in" }}
										field={<span> ... et {patient.grantees.length - 2} autre.s proche.s</span>}
										label=""
									/>
								)}
							</Grid.Column>
						</Grid.Row>
					)}
					{!isMobile() && !!displayAllPatientCard && (
						<Grid.Row style={styles.row}>
							<Grid.Column mobile={8} tablet={8} computer={16}>
								<ContainerField field={patientAddress !== "" ? patientAddress : "n.c."} icon={<Icon name="home" />} label="" />
							</Grid.Column>
						</Grid.Row>
					)}
				</Grid>
			)}
		</>
	);
};

export default SidebarPatientCard;
